import React, { Fragment, useEffect, useState } from "react";
import moment from 'moment'
import { GApageView } from '../..';
import { NavLink } from "react-router-dom";
import { useStorage } from '../../hook/useStorage';
import { Loader } from "semantic-ui-react";
import avatarImage from "../../../assets/images/sprites/avatar-person.svg";
import { Button } from "../../genericComponents";
import { ThemeProps } from "../../genericComponents/globalStyles";

import styled from "styled-components";


export default function UserMembership({ user, stripeSubscription, cancelSubscription }) {

  const [loading, setLoading] = useState(true);
  const image = useStorage(`avatars/${user.avatar}`);
  useEffect(() => {
    setLoading(true)
    GApageView('Home');

  }, []);

  useEffect(() => {

    setLoading(false)
  }, [user.email]);
  const parseDate = (someDate) => {
    let m = moment(someDate, 'YYYY-MM-DD');
    return m.format('MMM Do, YYYY')
  }

  return loading ? (<Loader active size={"massive"} />)
    : (<DataProfileContainer>
      <ImageContainer>
        {user?.avatar?.includes('https://')?(
          <ImgProfile alt="user" src={user.avatar} />
        ):
        image ? (
          <ImgProfile alt="user" src={image} />
        ) : (
            <ImgProfile alt="user" src={avatarImage} />
          )}
      </ImageContainer>
      <div>
        <NameTitle>
          {`${user.name} `}
          <TitleSubIndex>
            {user.pronouns}
          </TitleSubIndex>
        </NameTitle>
        {user.medical_school?.length > 0 && (
          <SubTitle>{user.medical_school}</SubTitle>
        )}
        <UlTags>
          {user?.specialties?.length > 0 && (
            <LiTags>
              <ATags>{user?.specialties.join(" ")}</ATags>
            </LiTags>
          )}
          {/* <LiTags>
            <ATags>{user.class_status} Student</ATags>
          </LiTags>
          {user.honors?.length > 0 &&
            user.honors.map((item, index) => (
              <LiTags key={index}>
                <ATags>{item}</ATags>
              </LiTags>
            ))} */}
        </UlTags>
      </div>
      <MembershipContainer>
        <div>
          <MembershipRow>
            <b>Membership</b>: {user.membership.name} Access
          </MembershipRow>

          {user.membership.type !== 'LifeTime' ?
            (<MembershipRow><b>Exp Date</b>: {parseDate(user.due_date)}</MembershipRow>) : null}


        </div>
        <div>

        {user.membership.type !== 'LifeTime' ?
          (<LinkToRenew to={`/payment`} >
            <RenewButton>Renew</RenewButton>
          </LinkToRenew>
          ) : null}
        
        {stripeSubscription&&(
          <Cancel onClick={()=>cancelSubscription({variables:{subscriptionId:stripeSubscription.id,email:user.email}})}>
            Cancel Subscription
          </Cancel>
        )}
        </div>
      </MembershipContainer>
    </DataProfileContainer>)
}

const LinkToRenew = styled(NavLink)`
  display:flex;
  flex-direction:column;
  justify-content:center;
`

const MembershipContainer = styled.div`
  margin: 56px auto;
  justify-content: space-around;
  width: 100%;
  bottom: 1em;
  display:flex;
`;

const MembershipRow = styled.div`
  font-size: 200%;
  margin:20px;
`

const RenewButton = styled(Button)`
  background-color: ${ThemeProps.color.gabaYellow};
  color: ${ThemeProps.color.darkBlue};
  padding: 10px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  min-width: 120px;
`;
const UlTags = styled.ul`
  list-style: none;
`;
const LiTags = styled.li`
  margin-top: 4px;
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  padding: 8px 16px;
  border-radius: 6px;
  background: rgba(114, 128, 219, 0.22);
`;
const ATags = styled.a`
  color: ${ThemeProps.color.darkBlue};
  font-size: 1.1em;
  font-weight: bold;
`;
const NameTitle = styled.p`
  font-size: 3.5em;
  margin-bottom: 0;
`;
const TitleSubIndex = styled.sub`
  font-size: 0.5em;
  margin-top: -32px;
  bottom: 1em;
`;
const SubTitle = styled.p`
  font-size: 1.9em;
  margin-bottom: 12px;
`;
const ImageContainer = styled.div`
  width: 140px;
  height: 140px;
  margin-right: 16px;
`;
const DataProfileContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-flow: row wrap;
`;
const ImgProfile = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 140px;
`;


const Cancel = styled(Button)`
  background-color: ${ThemeProps.color.softPurple};
  color: ${ThemeProps.color.darkBlue};
  padding: 10px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  min-width: 120px;
`;